import { useState } from "react";

const useInput = validateValue => {
  const [value, setValue] = useState("");
  const [valueTouched, setValueTouched] = useState(false);
  const valueIsValid = validateValue(value);
  const hasError = !valueIsValid && valueTouched;

  const valueChangeHandler = event => {
    setValue(event.target.value);
  };
  const valueBlurHandler = () => {
    setValueTouched(true);
  };
  const reset = () => {
    setValue("");
    setValueTouched(false);
  };
  const touch = () => {
    setValueTouched(true);
  };
  return {
    value,
    valueIsValid,
    hasError,
    valueChangeHandler,
    valueBlurHandler,
    reset,
    touch
  };
};

export default useInput;
